import { compile } from "path-to-regexp";

import { ROUTE_PATHS } from "@/constants/paths";

/** Product Type */

export function getProductTypeListUrl() {
  return ROUTE_PATHS.PRODUCT_TYPE_LIST;
}

export function getProductTypeFormUrl(params: {
  productTypeId: string | number;
}): string {
  return compile(ROUTE_PATHS.PRODUCT_TYPE_FORM)(params);
}

/** Product Group */

export function getProductGroupListUrl() {
  return ROUTE_PATHS.PRODUCT_GROUP_LIST;
}

export function getProductGroupFormUrl(params: {
  productGroupId: string | number;
}): string {
  return compile(ROUTE_PATHS.PRODUCT_GROUP_FORM)(params);
}

/** Category */

export function getCategoryListUrl() {
  return ROUTE_PATHS.CATEGORY_LIST;
}

export function getCategoryFormUrl(params: {
  categoryId: string | number;
}): string {
  return compile(ROUTE_PATHS.CATEGORY_FORM)(params);
}

export function getCategoryTreeUrl() {
  return ROUTE_PATHS.CATEGORY_TREE;
}

export function getSeoListUrl() {
  return ROUTE_PATHS.SEO_LIST_CATEGORY;
}

/** Product */

export function getProductListUrl() {
  return ROUTE_PATHS.PRODUCT_LIST;
}

export function getProductFormUrl(params: {
  productId: string | number;
}): string {
  return compile(ROUTE_PATHS.PRODUCT_FORM)(params);
}

/** Basis Product */

export function getBasisProductListUrl() {
  return ROUTE_PATHS.BASIS_PRODUCT_LIST;
}

export function getBasisProductFormUrl(params: {
  productId: string | number;
}): string {
  return compile(ROUTE_PATHS.BASIS_PRODUCT_FORM)(params);
}

/** Special */

export function getSpecialListUrl() {
  return ROUTE_PATHS.SPECIAL_LIST;
}

export function getSpecialFormUrl(params: {
  specialId: string | number;
}): string {
  return compile(ROUTE_PATHS.SPECIAL_FORM)(params);
}

/** Brand */

export function getBrandListUrl() {
  return ROUTE_PATHS.BRAND_LIST;
}

export function getBrandFormUrl(params: { brandId: string | number }): string {
  return compile(ROUTE_PATHS.BRAND_FORM)(params);
}

/** Collection */

export function getCollectionListUrl() {
  return ROUTE_PATHS.COLLECTION_LIST;
}

export function getCollectionFormUrl(params: {
  collectionId: string | number;
}): string {
  return compile(ROUTE_PATHS.COLLECTION_FORM)(params);
}

/** Field */

export function getFieldListUrl(params: { productTypeId: string | number }) {
  return compile(ROUTE_PATHS.FIELD_LIST)(params);
}

export function getFieldCreateFormUrl(params: {
  productTypeId: string | number;
  fieldId: string | number;
}): string {
  return compile(ROUTE_PATHS.FIELD_CREATE_FORM)(params);
}

export function getFieldEditFormUrl(params: {
  fieldId: string | number;
}): string {
  return compile(ROUTE_PATHS.FIELD_EDIT_FORM)(params);
}

/** Term */

export function getTermListUrl() {
  return ROUTE_PATHS.TERM_LIST;
}

export function getTermFormUrl(params: { termId: string | number }): string {
  return compile(ROUTE_PATHS.TERM_FORM)(params);
}

export function getLinkListUrl() {
  return ROUTE_PATHS.TERM_LINK_LIST;
}

/** TermLink */

export function getTermLinkCreateFormUrl(params: {
  termId: string | number;
  termLinkId: string | number;
}): string {
  return compile(ROUTE_PATHS.TERM_LINK_FORM_CREATE)(params);
}

export function getTermLinkUpdateFormUrl(params: {
  termLinkId: string | number;
}): string {
  return compile(ROUTE_PATHS.TERM_LINK_FORM_UPDATE)(params);
}
